import { Article } from '../../types'

export const MOCK_TECH_ARTICLES: Article[] = [
  {
    source: {
      name: 'TrueAchievements',
    },
    title:
      'Game Pass adds long-awaited survival game Valheim for consoles today - TrueAchievements',
    author: 'Heidi Nicholas',
    url: 'https://www.trueachievements.com/n53174/valheim-xbox-game-pass',
    urlToImage:
      'https://www.trueachievements.com/imgs/137571/valheim-xbox-game-pass.jpg',
    publishedAt: '2023-03-14T10:32:43Z',
  },
  {
    source: {
      name: 'BikeRadar.com',
    },
    title:
      "Canyon's new Grizl CF SL 7 Throwback is 'just a mountain bike from the 90s'... kinda - BikeRadar",
    author: 'Oscar Huckle',
    url: 'https://www.bikeradar.com/news/canyon-grizl-cf-sl-7-throwback/',
    urlToImage:
      'https://images.immediate.co.uk/production/volatile/sites/21/2023/03/471855-W9A0955-042536-original-1678480037-440db4d.jpg?quality=45&resize=620,413',
    publishedAt: '2023-03-14T10:00:56Z',
  },
  {
    source: {
      name: 'Push Square',
    },
    title:
      'Latest PS5 Firmware Update Is Available to Download Now - Push Square',
    author: 'Stephen Tailby',
    url: 'https://www.pushsquare.com/news/2023/03/latest-ps5-firmware-update-is-available-to-download-now',
    urlToImage: 'https://images.pushsquare.com/f425dc1b036f8/1280x720.jpg',
    publishedAt: '2023-03-14T09:30:00Z',
  },
  {
    source: {
      name: 'Engadget',
    },
    title:
      "Sennheiser's 'Profile' microphone for streamers gets a lot right - Engadget",
    author: 'https://www.engadget.com/about/editors/james-trew',
    url: 'https://www.engadget.com/sennheisers-profile-microphone-for-streamers-gets-a-lot-right-090017043.html',
    urlToImage:
      'https://s.yimg.com/uu/api/res/1.2/fHQMJOSFLpiVYVEfV2QKag--~B/Zmk9ZmlsbDtoPTYzMDtweW9mZj0wO3c9MTIwMDthcHBpZD15dGFjaHlvbg--/https://media-mbst-pub-ue1.s3.amazonaws.com/creatr-uploaded-images/2023-03/91aee5f0-c264-11ed-877d-c62c54c26d20.cf.jpg',
    publishedAt: '2023-03-14T09:02:13Z',
  },
  {
    source: {
      name: 'GameSpot',
    },
    title: "Naughty Dog's Next Project Isn't The Last Of Us 3 - GameSpot",
    author: 'Hayley Williams',
    url: 'https://www.gamespot.com/articles/naughty-dogs-next-project-isnt-the-last-of-us-3/1100-6512308/',
    urlToImage:
      'https://www.gamespot.com/a/uploads/screen_kubrick/1597/15975876/4111840-1990710-652686_20120814_003.jpg',
    publishedAt: '2023-03-14T06:50:58Z',
  },
  {
    source: {
      name: 'Nintendo Life',
    },
    title:
      'Switch Online N64 Wireless Controller Restocks Coming Later This Week - Nintendo Life',
    author: 'Liam Doolan',
    url: 'https://www.nintendolife.com/news/2023/03/switch-online-n64-wireless-controller-restocks-coming-later-this-week',
    urlToImage: 'https://images.nintendolife.com/708307a8cdb57/1280x720.jpg',
    publishedAt: '2023-03-14T05:00:00Z',
  },
  {
    source: {
      name: 'ComicBook.com',
    },
    title: 'Warhammer 40K Teases 10th Edition - ComicBook.com',
    author: 'Christian Hoffer',
    url: 'https://comicbook.com/gaming/news/warhammer-40k-10th-edition-tease-games-workshop/',
    urlToImage:
      'https://sportshub.cbsistatic.com/i/2023/03/14/f74a2bc0-59c1-4e4c-9f6b-badb1a4cc400/warhammer-40k-10.jpg?width=1200',
    publishedAt: '2023-03-14T01:17:00Z',
  },
  {
    source: {
      name: 'Nintendo Life',
    },
    title:
      'Capcom Reminds Monster Hunter Fans To Grab 3DS & Wii U Entries Before eShop Closure - Nintendo Life',
    author: 'Liam Doolan',
    url: 'https://www.nintendolife.com/news/2023/03/capcom-reminds-monster-hunter-fans-to-grab-3ds-and-wii-u-entries-before-eshop-closure',
    urlToImage: 'https://images.nintendolife.com/15e45da392cc7/1280x720.jpg',
    publishedAt: '2023-03-14T01:15:00Z',
  },
  {
    source: {
      name: 'Business Insider',
    },
    title:
      'Elon Musk hints Starship rocket may explode on first orbital launch - Business Insider',
    author: 'Marianne Guenot, Morgan McFall-Johnsen',
    url: 'https://www.businessinsider.com/elon-musk-estimates-spacex-starship-first-launch-odds-success-explosion-2023-3',
    urlToImage:
      'https://i.insider.com/640b9669d81e7e0018be0c8b?width=1200&format=jpeg',
    publishedAt: '2023-03-13T23:14:00Z',
  },
  {
    source: {
      name: 'MacRumors',
    },
    title:
      "Refurbished iPhone 13 Models Now Available From Apple's U.S. Store - MacRumors",
    author: 'Juli Clover',
    url: 'https://www.macrumors.com/2023/03/13/apple-refurbished-iphone-13/',
    urlToImage:
      'https://images.macrumors.com/t/kgQxTIwcUmr1CDdBJ7UGdGnFFCU=/1600x/article-new/2023/03/apple-refurbished-iphone-13.jpg',
    publishedAt: '2023-03-13T22:53:53Z',
  },
  {
    source: {
      name: 'PhoneArena',
    },
    title:
      "Galaxy S23 Ultra's moon shot called fake on social media - PhoneArena",
    author: 'Alan Friedman',
    url: 'https://www.phonearena.com/news/samsungs-galaxy-s23-ultra-moon-shots-criticized-as-fakes_id146189',
    urlToImage:
      'https://m-cdn.phonearena.com/images/article/146189-wide-two_1200/Galaxy-S23-Ultras-moon-shot-called-fake-on-social-media.jpg',
    publishedAt: '2023-03-13T22:44:33Z',
  },
  {
    source: {
      name: 'EventHubs',
    },
    title:
      'AI Kratos hits up AI Ed Boon about his chances of getting back into Mortal Kombat 12 - EventHubs',
    author: "Dakota 'DarkHorse' Hills",
    url: 'https://www.eventhubs.com/news/2023/mar/13/kratos-boon-mortal-kombat/',
    urlToImage:
      'https://media.eventhubs.com/images/2023/03/13-kratos-boon-mortal-kombatt.webp',
    publishedAt: '2023-03-13T22:33:31Z',
  },
  {
    source: {
      name: 'Kotaku',
    },
    title:
      'Russian Hackers Threaten Ukrainian Stalker 2 Devs, Bad Idea - Kotaku',
    author: 'Luke Plunkett',
    url: 'https://kotaku.com/stalker-2-gsc-game-world-ukraine-russia-hackers-pc-1850221715',
    urlToImage:
      'https://i.kinja-img.com/gawker-media/image/upload/c_fill,f_auto,fl_progressive,g_center,h_675,pg_1,q_80,w_1200/0c658ff6aeffa496cdc52b79119a2769.jpg',
    publishedAt: '2023-03-13T22:30:00Z',
  },
  {
    source: {
      name: 'Polygon',
    },
    title:
      'This game fixes Myst by adding guns, demons, and a sick metal soundtrack - Polygon',
    author: 'Cass Marshall',
    url: 'https://www.polygon.com/23638533/myst-fps-mod-woe-industries-point-and-kill-adventure',
    urlToImage:
      'https://cdn.vox-cdn.com/thumbor/Pc9hH5ysWZSEtmcph3SKfZibBus=/0x38:1920x1043/fit-in/1200x630/cdn.vox-cdn.com/uploads/chorus_asset/file/24504995/ss_fdc850f5977f44b433613dc94c03b3deb3b973d1.jpg',
    publishedAt: '2023-03-13T21:50:44Z',
  },
  {
    source: {
      name: 'Eurogamer.net',
    },
    title:
      "The Witcher 3's latest patch promises improved Performance Mode on consoles - Eurogamer.net",
    author: 'Matt Wales',
    url: 'https://www.eurogamer.net/the-witcher-3s-latest-patch-promises-improved-performance-mode-on-consoles',
    urlToImage:
      'https://assets.reedpopcdn.com/Witcher-PC-Site.jpg/BROK/thumbnail/1200x630/Witcher-PC-Site.jpg',
    publishedAt: '2023-03-13T21:25:30Z',
  },
  {
    source: {
      name: '9to5google.com',
    },
    title:
      'Oppo Find N2 Flip can now run full Android apps on its cover screen (unofficially) - 9to5Google',
    author: null,
    url: 'https://9to5google.com/',
    urlToImage: null,
    publishedAt: '2023-03-13T21:12:00Z',
  },
  {
    source: {
      name: 'TechRadar',
    },
    title:
      "WiiM's cheap wireless high-res audio streamer turns any speaker into a Sonos - TechRadar",
    author: 'Al Griffin',
    url: 'https://www.techradar.com/news/wiims-cheap-wireless-high-res-audio-streamer-turns-any-speaker-into-a-sonos',
    urlToImage:
      'https://cdn.mos.cms.futurecdn.net/vmLRAVUBDtUFBHMWSP76xW-1200-80.jpg',
    publishedAt: '2023-03-13T21:07:02Z',
  },
  {
    source: {
      name: 'IGN',
    },
    title:
      "Nintendo's Doug Bowser Says Tears of the Kingdom's $70 Price Reflects Its 'Full, Deeply Immersive Experience' - IGN",
    author: 'Logan Plant',
    url: 'https://www.ign.com/articles/nintendos-doug-bowser-says-tears-of-the-kingdoms-70-price-reflects-its-full-deeply-immersive-experience',
    urlToImage:
      'https://assets-prd.ignimgs.com/2023/02/08/zelda-tearsofthekingdom-3-blogroll-1675898731861.jpg?width=1280',
    publishedAt: '2023-03-13T21:03:03Z',
  },
  {
    source: {
      name: 'Robb Report',
    },
    title:
      'A Former Warner Bros. Exec Just Listed His Sprawling Calabasas Ranch for $25 Million - Yahoo',
    author: 'Abby Montanez',
    url: 'https://robbreport.com/shelter/celebrity-homes/bob-daly-california-ranch-1234817657/',
    urlToImage:
      'https://media.zenfs.com/en/robb_report_967/807ff69c95eb111d9e1e4793d55bbc70',
    publishedAt: '2023-03-13T21:00:00Z',
  },
  {
    source: {
      name: '9to5google.com',
    },
    title:
      'Nothing Ear (2) full specs surface as more official-looking renders leak [Gallery] - 9to5Google',
    author: 'Ben Schoon',
    url: 'https://9to5google.com/2023/03/13/nothing-ear-2-specs/',
    urlToImage:
      'https://i0.wp.com/9to5google.com/wp-content/uploads/sites/4/2023/03/nothing-ear-2-leak-4.jpg?resize=1200%2C628&quality=82&strip=all&ssl=1',
    publishedAt: '2023-03-13T20:42:00Z',
  },
  {
    source: {
      name: 'Eurogamer.net',
    },
    title:
      'Activision "committed" to Call of Duty: Mobile despite Microsoft claims it could be "phased out" - Eurogamer.net',
    author: 'Matt Wales',
    url: 'https://www.eurogamer.net/activision-committed-to-call-of-duty-mobile-despite-microsoft-claims-it-could-be-phased-out',
    urlToImage:
      'https://assets.reedpopcdn.com/over-300m-people-have-downloaded-call-of-duty-mobile-1603445834191.jpg/BROK/thumbnail/1200x630/over-300m-people-have-downloaded-call-of-duty-mobile-1603445834191.jpg',
    publishedAt: '2023-03-13T20:26:47Z',
  },
  {
    source: {
      name: 'NASA',
    },
    title:
      "Study Finds Ocean Currents May Affect Rotation of Europa's Icy Crust - NASA",
    author: null,
    url: 'https://www.nasa.gov/feature/jpl/study-finds-ocean-currents-may-affect-rotation-of-europa-s-icy-crust',
    urlToImage:
      'http://www.nasa.gov/sites/default/files/thumbnails/image/1-pia25695-europa_globe_by_juno.jpg',
    publishedAt: '2023-03-13T20:26:09Z',
  },
  {
    source: {
      name: 'GameSpot',
    },
    title:
      '"No Plans" For Diablo 4 To Come To Game Pass, Blizzard Confirms - GameSpot',
    author: 'Cameron Koch',
    url: 'https://www.gamespot.com/articles/no-plans-for-diablo-4-to-come-to-game-pass-blizzard-confirms/1100-6512298/',
    urlToImage:
      'https://www.gamespot.com/a/uploads/screen_kubrick/1647/16470614/4111581-diablo4won%27tbeongamepass.jpg',
    publishedAt: '2023-03-13T20:18:43Z',
  },
  {
    source: {
      name: 'TechCrunch',
    },
    title:
      'Spotify’s new ‘DJ’ feature is the first step into the streamer’s AI-powered future - TechCrunch',
    author: 'Sarah Perez',
    url: 'https://techcrunch.com/2023/03/13/spotifys-new-dj-feature-is-the-first-step-into-the-streamers-ai-powered-future/',
    urlToImage:
      'https://techcrunch.com/wp-content/uploads/2023/03/ai-dj-stage-demo.jpg?resize=1200,854',
    publishedAt: '2023-03-13T20:12:58Z',
  },
  {
    source: {
      name: 'Gizmodo.com',
    },
    title:
      'Google Pixel 7a Leak Shows a 90Hz Refresh Rate, More Memory - Gizmodo',
    author: 'Florence Ion',
    url: 'https://gizmodo.com/google-pixel-7a-refresh-rate-memory-90hz-6a-leak-specs-1850220667',
    urlToImage:
      'https://i.kinja-img.com/gawker-media/image/upload/c_fill,f_auto,fl_progressive,g_center,h_675,pg_1,q_80,w_1200/85fdd8e4f67c386da11b50c47f90120c.jpg',
    publishedAt: '2023-03-13T19:50:00Z',
  },
]
